import { ArrowLeft, ChevronLeft } from 'lucide-react';
import { LAYOUT_BTN_BACK } from './tokens';

interface AppBackButtonProps {
  onClick: () => void;
  label?: string;
  icon?: 'arrow' | 'chevron';
  className?: string;
}

export function AppBackButton({
  onClick,
  label = 'Início',
  icon = 'arrow',
  className = '',
}: AppBackButtonProps) {
  const Icon = icon === 'chevron' ? ChevronLeft : ArrowLeft;

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${LAYOUT_BTN_BACK} ${className}`.trim()}
    >
      <Icon className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span className="hidden sm:inline">{label}</span>
    </button>
  );
}
